module.exports = __webpack_public_path__ + "img/yggl.26f6e7ae.png";